/**
 * The authenticated branch's boundary. A throw inside a screen renders here, still inside the
 * shell — the user keeps the nav and their context instead of being dropped somewhere unfamiliar
 * mid-shift.
 */

import { isRouteErrorResponse, useNavigate, useRouteError } from 'react-router';

import { Button, ErrorState } from '@/shared/ui';

export function ShellErrorBoundary() {
  const error = useRouteError();
  const navigate = useNavigate();

  if (isRouteErrorResponse(error) && error.status === 404) {
    return (
      <div className="grid h-full place-items-center px-6">
        <ErrorState
          title="That screen does not exist"
          body="The link may be out of date. Use the bar at the bottom to get back."
          onRetry={() => void navigate('/sell')}
          retryLabel="Go to the till"
        />
      </div>
    );
  }

  return (
    <div className="grid h-full place-items-center px-6">
      <div className="text-center">
        <ErrorState
          title="This screen could not be shown"
          body="Nothing was charged and nothing was lost. Go back to the till and try again — if it keeps happening, tell the owner what you were doing."
        />

        <Button variant="quiet" className="mt-4" onClick={() => void navigate('/sell')}>
          Back to the till
        </Button>
      </div>
    </div>
  );
}
